export function getChatrooms(state) {
  return state.classrooms;
}
